import React, { useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Divider, Message, Placeholder } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { checkoutHtmlAtom, checkoutErrorAtom, checkoutLoadingAtom, checkoutSuccessAtom } from "./state.js";
import { cartAtom } from "./atoms/cartAtom.js";
import { userAtom } from "./atoms/authAtom";
import { responsiveAtom } from "./atoms/responsiveAtom";
import Title from "./components/Title.js";

const PayPage = ({}) => {
  const [cart, setCart] = useAtom(cartAtom);
  const [checkoutHtml, setCheckoutHtml] = useAtom(checkoutHtmlAtom);
  const [checkoutLoading, setCheckoutLoading] = useAtom(checkoutLoadingAtom);
  const [checkoutError, setCheckoutError] = useAtom(checkoutErrorAtom);
  const [checkoutSuccess, setCheckoutSuccess] = useAtom(checkoutSuccessAtom);
  const checkoutContainerRef = useRef(null);
  const [responsive, setResponsive] = useAtom(responsiveAtom);
  const [user] = useAtom(userAtom);

  const navigate = useNavigate();
  const { slug } = useParams();
  const { t } = useTranslation();

  const fetchCheckoutHtml = async () => {
    // setResponsive({ ...responsive, cartVisible: false, leftMenuVisible: false, topBarVisible: false });
    setCheckoutLoading(true);
    try {
      const response = await fetch(`/pay/${slug}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.text();
      setCheckoutHtml(data);
      setCheckoutLoading(false);
    } catch (error) {
      setCheckoutError(true);
      setCheckoutLoading(false);
    }
  };

  useEffect(() => {
    fetchCheckoutHtml();
  }, []);

  useEffect(() => {
    if (checkoutHtml) {
      const checkoutContainer = checkoutContainerRef.current;
      checkoutContainer.innerHTML = checkoutHtml;
      const scriptsTags = checkoutContainer.getElementsByTagName("script");
      for (let i = 0; i < scriptsTags.length; i++) {
        const parentNode = scriptsTags[i].parentNode;
        const newScriptTag = document.createElement("script");
        newScriptTag.type = "text/javascript";
        newScriptTag.text = scriptsTags[i].text;
        parentNode.removeChild(scriptsTags[i]);
        parentNode.appendChild(newScriptTag);
      }

      window._klarnaCheckout(function (api) {
        api.on({
          change: function (data, callback) {
            // callback({ should_proceed: true, message: "Sorry, your shipping address is not supported." });
          },
          shipping_address_change: function (data, callback) {
            console.log("shipping_address_change", data);
          },
        });
      });
    } else {
      const checkoutContainer = checkoutContainerRef.current;
      if (checkoutContainer) {
        checkoutContainer.innerHTML = "";
      }
    }
  }, [cart?.checkingOut, checkoutHtml, checkoutSuccess, setCart]);

  if (checkoutError) {
    return (
      <Message negative size="big">
        <Message.Header>{t("something_went_wrong")}</Message.Header>
        <Message.Content>{t("try_again_later")}</Message.Content>
      </Message>
    );
  }

  if (cart.checkingOut && !checkoutHtml) {
    return (
      <Placeholder fluid>
        <Placeholder.Header image>
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Header>
        <Placeholder.Paragraph>
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Paragraph>
      </Placeholder>
    );
  }

  return (
    <React.Fragment>
      {checkoutError && (
        <Message negative size="big">
          <Message.Header>{t("something_went_wrong")}</Message.Header>
        </Message>
      )}
      {checkoutLoading && (
        <Message info size="big">
          <Message.Header>{t("checking_out")}</Message.Header>
        </Message>
      )}

      {checkoutLoading && (
        <Placeholder fluid>
          <Placeholder.Header image>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
        </Placeholder>
      )}
      {!checkoutHtml && (
        <Message info size="big">
          <Message.Header>Loading</Message.Header>
        </Message>
      )}
      <div ref={checkoutContainerRef} id="klarna-checkout-container"></div>
    </React.Fragment>
  );
};

export default PayPage;
